<template>
  <div class="page-header-area">
    <button v-if="showBack" class="btn-back" @click="$emit('back')">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M19 12H5" />
        <path d="M12 19l-7-7 7-7" />
      </svg>
      {{ backText }}
    </button>
    <div class="page-title-group">
      <h1 class="page-title">{{ title }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    showBack: { type: Boolean, default: true },
    backText: { type: String, default: "返回" }
  }
};
</script>

<style scoped>
.page-header-area {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  height: 44px;
  border: 1px solid rgba(42, 122, 75, 0.25);
  border-radius: 9999px;
  background: #ffffff;
  color: #20863F;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;
  box-sizing: border-box;
}

.btn-back:hover {
  background: #eef7f1;
}

.page-title-group {
  flex: 1;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  color: #123b25;
  margin: 0;
  letter-spacing: 0.02em;
}

.page-subtitle {
  margin: 4px 0 0;
  color: #555;
  font-size: 15px;
}

@media (max-width: 768px) {
  .page-header-area {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 24px;
  }

  .page-title {
    font-size: 28px;
  }

  .page-subtitle {
    font-size: 14px;
  }
}
</style>
